module.exports = __webpack_public_path__ + "static/flags/CS-947c4dd70b99d9c3dd97a42592921833.gif";